import type * as Y from 'yjs';

export const HiveDataSyncCacheOrigin = Symbol('HiveDataSyncCacheOrigin');

/**
 * Interface for caching the data sync Yjs doc in the browser.
 */
export interface HiveDataSyncBrowserCache {
    /**
     * Register a document to synchronize it with the cache.
     */
    registerDoc(doc: Y.Doc): void;

    /**
     * Clear the cache.
     */
    clear(): Promise<void>;
}
